import Swiper from 'swiper';
import 'swiper/css';

var $ = jQuery;

export default class NewsSlider {

    initSliders() {
        const NEWSCONTAINERS = document.querySelectorAll('.mtt-news-slider');
        if (NEWSCONTAINERS.length > 0) {
            for (let i = 0; i < NEWSCONTAINERS.length; i++) {
                new Slider(NEWSCONTAINERS[i]);
            }
        }
    }
}

class Slider {

    constructor(CONTAINER) {

        this.CONTAINER = CONTAINER;
        this.TARGET_CONTAINER = this.CONTAINER.querySelector('.mtt-news-slider__target');
        this.TOGGLES = this.CONTAINER.querySelectorAll('.mtt-filter__toggle');
        this.LOADER = this.CONTAINER.querySelector('.mtt-news-slider__loader');

        // create swiper on init
        this.SWIPER = this.createSwiper();

        this.TOGGLES.length > 0 && this.toggleHandler();
    }

    createSwiper() {

        const PREV = this.CONTAINER.querySelector('.swiper-button-prev');
        const NEXT = this.CONTAINER.querySelector('.swiper-button-next');

        return new Swiper(this.CONTAINER.querySelector('.swiper-container'), {
            slidesPerView: 1.25,
            speed: 800,
            spaceBetween: 16,
            freeMode: false,
            navigation: {
                nextEl: NEXT,
                prevEl: PREV,
            },
            breakpoints: {
                321: { slidesPerView: 1.25 },
                581: { slidesPerView: 2 },
                961: { slidesPerView: 3 },
            }

        });
    }
}